// Mapping db col headers to formatted description
export const shipmentDbCols = {
  status: "Status",
  bol: "BOL",
  mbl_mawb: "MBL / MAWB",
  hbl_hawb: "HBL / HAWB",
  vessel_voyage: "Vessel / voyage",
  shipper: "Shipper",
  from: "From",
  to: "To",
  weight: "Weight",
  volume: "Volume",
  consignee_or_cargo_owner: "Consignee or owner",
  cargo_description: "Cargo description",
  status: "Status",
  container: "Container",
};
